export enum PortalRoleType {
  BROKER = 'Broker',
  PROCESSOR_MANAGER = 'Processor Manager',
}